import { CSSProperties, FC } from 'react';

import YbCoreDivider from '@yubi/yb-core-divider-v3';
import { YbDividerProps } from '@yubi/yb-core-divider-v3/dist/dts/index.types';

type DividerViewV3Props = YbDividerProps & {
  className?: string;
  style?: CSSProperties;
};

const DividerViewV3: FC<DividerViewV3Props> = ({
  className,
  style,
  ...props
}) => {
  return (
    <div className={className} style={style}>
      <YbCoreDivider {...props} />
    </div>
  );
};

export default DividerViewV3;
